<div class="loading-overlay" [class.show]="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
